import { takeLatest, all } from 'redux-saga/effects';
import apiSaga from 'legacy-src/shared/util/apiSagaGenerator';
import { applyFilterCustomLabel } from 'legacy-src/utility/AssessmentFilterProvider';

import {
  fetchAssessments,
  fetchSubjects,
  fetchCategories,
  fetchGroupedAssignments,
} from './actions';

/**
 * Assessments saga.
 * Create a new api saga for fetching assessment data.
 *
 * @param {Object} action.payload Data object.
 * @yield {apiSaga}               Api Response.
 */
function* assessmentsSaga({ payload }) {
  yield apiSaga(fetchAssessments, {
    url: `tagging/api/subject/${payload.initId}/items/`,
    data: payload.params,
    silent: payload.silent,
    callback: payload.callback,
    callbackValue: payload.callbackValue,
  });
}

/**
 * Subjects saga.
 * Create a new api saga for fetching subjects.
 *
 * @yield {apiSaga} Api Response.
 */
function* subjectsSaga({ payload }) {
  yield apiSaga(fetchSubjects, {
    url: 'assessments/api/subjects/',
    data: payload.params,
  });
}

/**
 * Categories saga.
 * Create a new api saga for fetching categories..
 *
 * @param {Object} options.payload Data object.
 * @yield {apiSaga}                Api Response.
 */
function* categoriesSaga({ payload }) {
  const { initId, minimal_fields_only, subunitLabel, educationPeriod } =
    payload;
  yield apiSaga(
    fetchCategories,
    {
      url: `tagging/api/subject/${initId}/categories/`,
      data: { minimal_fields_only, educationPeriod },
    },
    (response) => {
      if (subunitLabel) {
        return applyFilterCustomLabel(response, subunitLabel);
      }
      return response;
    },
  );
}

/**
 * Grouped Assignments Saga.
 * Create a new api saga for fetching grouped assignments.
 *
 * @param {Object} action.payload Data object.
 * @yield {apiSaga}               Api Response.
 */
function* groupedAssignmentsSaga({ payload }) {
  yield apiSaga(fetchGroupedAssignments, {
    url: `assessments/api/chameleon/assessments/${payload.subjectId}/`,
    data: payload.params,
    silent: payload.silent,
  });
}

/**
 * Assessment Saga
 *
 * @yield {Saga} All sagas that belong to assessments.
 */
export default function* assessmentSaga() {
  yield all([
    takeLatest(fetchAssessments.TRIGGER, assessmentsSaga),
    takeLatest(fetchSubjects.TRIGGER, subjectsSaga),
    takeLatest(fetchCategories.TRIGGER, categoriesSaga),
    takeLatest(fetchGroupedAssignments.TRIGGER, groupedAssignmentsSaga),
  ]);
}
